// Soundboard – Menüeintrag im Kanal-Header (zeigt sich nur in Sprachkanälen, siehe SoundboardPanel).
import type { ExtraMenuItem } from './index';
import { SoundboardPanel } from './soundboard';

export const soundboardMenuItems: ExtraMenuItem[] = [{ id: 'soundboard', label: 'Soundboard', slot: 'channelHeader', component: SoundboardPanel, display: 'panel', channelTypes: ['VOICE'] }];
